import styled, { keyframes, useTheme } from 'styled-components'

import type { DefaultProps } from './DefaultProps'
import { Wrapper as DefaultWrapper } from './Wrapper'

const Wrapper = styled(DefaultWrapper)`
	.rotate {
		animation: ${keyframes`
			to {
				transform: rotate(360deg);
			}
		`} 2s linear infinite;
		transform-origin: center center;
		transform-box: fill-box;
	}

	.reverse {
		animation-direction: reverse;
	}

	.rotateTop {
		animation-duration: 2.5s;
	}

	.rotateLeft {
		animation-duration: 1.5s;
	}

	.rotateRight {
		animation-duration: 5s;
	}
`

export const HeaderIconRotatingCogs = ({ title, ...rest }: DefaultProps) => {
	const theme = useTheme() as any

	return (
		<Wrapper {...rest}>
			<svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 512 512'>
				<g clipPath='url(#a)'>
					<path
						fill='url(#b)'
						d='M383 172h-1c-32-1-62-14-83-38A170 170 0 0 0 0 248a170 170 0 0 0 244 151c19-9 42-7 59 6a131 131 0 0 0 209-103c0-72-57-130-129-130Z'
					/>
					<path
						className='rotate rotateRight'
						fill={theme.color.primary}
						d='m488 296-30-9c-3-12-8-23-14-33l15-28c2-2 1-5-1-7l-20-21c-2-1-5-2-7-1l-28 16c-10-7-21-11-33-14l-9-30c-1-3-3-5-6-5h-29c-3 0-5 2-6 5l-8 30c-12 3-24 7-34 14l-27-16c-3-1-5 0-7 1l-21 21c-2 2-2 5-1 7l15 28c-6 10-11 21-14 33l-30 9c-2 1-4 3-4 6v29c0 2 2 5 4 5l30 9c3 12 8 23 14 34l-15 27c-1 2-1 5 1 7l21 21c2 2 4 2 7 1l27-15c10 6 22 11 34 14l8 30c1 2 3 4 6 4h29c3 0 5-2 6-4l9-30c12-3 23-8 33-14l28 15c2 1 5 1 7-1l20-21c2-2 3-5 1-7l-15-27c6-11 11-22 14-34l30-9c3 0 5-3 5-5v-29c0-3-2-5-5-6Zm-147 95a75 75 0 1 1 0-150 75 75 0 0 1 0 150Z'
						opacity='.1'
					/>
					<path
						className='rotate rotateLeft'
						fill={theme.color.primary}
						d='m181 250-16-5c-2-6-4-12-8-18l8-15v-4l-11-11h-4l-15 8c-5-3-11-6-18-8l-5-16c0-1-1-2-3-2H94l-4 2-4 16c-7 2-13 5-18 8l-15-8h-4l-11 11-1 4 9 15c-4 6-6 12-8 18l-16 5c-2 0-3 1-3 3v16l3 3 16 4c2 7 4 13 8 19l-9 14 1 4 11 11c1 1 3 2 4 1l15-8c5 3 11 6 18 7l4 16c1 2 2 3 4 3h15c2 0 3-1 3-3l5-16c7-1 13-4 18-7l15 8c1 1 3 0 4-1l11-11v-4l-8-14c4-6 6-12 8-19l16-4 2-3v-16c0-2-1-3-2-3Zm-80 37a26 26 0 1 1 0-52 26 26 0 0 1 0 52Z'
						opacity='.1'
					/>
					<path
						className='rotate reverse rotateTop'
						fill={theme.color.primary}
						d='m290 94-17-4-8-20 9-16-1-4-12-12-4-1-16 9-19-8-5-17c-1-2-2-3-4-3h-17c-1 0-3 1-3 3l-5 17-20 8-16-9-4 1-12 12v4l9 16c-4 6-7 13-9 20l-17 4c-2 1-3 2-3 4v17c0 1 1 3 3 3l17 5c2 7 5 14 9 20l-9 16v4l12 12h4l16-9c6 4 13 7 20 9l5 17c0 2 2 3 3 3h17c2 0 3-1 4-3l5-17c7-2 13-5 19-9l16 9h4l12-12 1-4-9-16 8-20 17-5c2 0 3-2 3-3V98c0-2-1-3-3-4Zm-85 47a34 34 0 1 1 0-69 34 34 0 0 1 0 69Z'
						opacity='.1'
					/>
					<path
						className='rotate rotateRight'
						fill={theme.color.cardBackground}
						d='m488 317-30-9c-3-12-8-23-14-33l15-28c2-2 1-5-1-7l-20-21c-2-1-5-2-7-1l-28 16c-10-7-21-11-33-14l-9-30c-1-3-3-5-6-5h-29c-3 0-5 2-6 5l-8 30c-12 3-24 7-34 14l-27-16c-3-1-5 0-7 1l-21 21c-2 2-2 5-1 7l15 28c-6 10-11 21-14 33l-30 9c-2 1-4 3-4 6v29c0 2 2 5 4 5l30 9c3 12 8 23 14 34l-15 27c-1 2-1 5 1 7l21 21c2 2 4 2 7 1l27-15c10 6 22 11 34 14l8 30c1 2 3 4 6 4h29c3 0 5-2 6-4l9-30c12-3 23-8 33-14l28 15c2 1 5 1 7-1l20-21c2-2 3-5 1-7l-15-27c6-11 11-22 14-34l30-9c3 0 5-3 5-5v-29c0-3-2-5-5-6Zm-147 95a75 75 0 1 1 0-150 75 75 0 0 1 0 150Z'
					/>
					<path
						className='rotate rotateLeft'
						fill={theme.color.focus}
						d='m181 271-16-5c-2-6-4-12-8-18l8-15v-4l-11-11h-4l-15 8c-5-3-11-6-18-8l-5-16c0-1-1-2-3-2H94l-4 2-4 16c-7 2-13 5-18 8l-15-8h-4l-11 11-1 4 9 15c-4 6-6 12-8 18l-16 5c-2 0-3 1-3 3v16l3 3 16 4c2 7 4 13 8 19l-9 14 1 4 11 11c1 1 3 2 4 1l15-8c5 3 11 6 18 7l4 16c1 2 2 3 4 3h15c2 0 3-1 3-3l5-16c7-1 13-4 18-7l15 8c1 1 3 0 4-1l11-11v-4l-8-14c4-6 6-12 8-19l16-4 2-3v-16c0-2-1-3-2-3Zm-80 37a26 26 0 1 1 0-52 26 26 0 0 1 0 52Z'
					/>
					<path
						className='rotate reverse rotateTop'
						fill={theme.color.cardBackground}
						d='m290 115-17-4-8-20 9-16-1-4-12-12-4-1-16 9-19-8-5-17c-1-2-2-3-4-3h-17c-1 0-3 1-3 3l-5 17-20 8-16-9-4 1-12 12v4l9 16c-4 6-7 13-9 20l-17 4c-2 1-3 2-3 4v17c0 1 1 3 3 3l17 5c2 7 5 14 9 20l-9 16v4l12 12h4l16-9c6 4 13 7 20 9l5 17c0 2 2 3 3 3h17c2 0 3-1 4-3l5-17c7-2 13-5 19-9l16 9h4l12-12 1-4-9-16 8-20 17-5c2 0 3-2 3-3v-17c0-2-1-3-3-4Zm-85 47a34 34 0 1 1 0-69 34 34 0 0 1 0 69Z'
					/>
					<path
						fill={theme.color.primary}
						d='M341 417a80 80 0 0 1-67-124 5 5 0 1 1 9 6c-8 11-12 24-12 38a70 70 0 1 0 29-57 5 5 0 1 1-5-8 80 80 0 1 1 46 145Z'
					/>
					<path
						className='rotate rotateRight'
						fill={theme.color.primary}
						d='M355 494h-29c-5 0-9-3-10-8l-8-27c-11-3-21-7-30-13l-25 14c-4 3-9 2-13-2l-20-20c-4-4-5-9-2-13l14-25c-6-10-10-20-13-30l-27-8c-5-1-8-5-8-10v-29c0-5 3-10 8-11l27-8c3-10 7-20 13-30l-14-24c-3-5-2-10 2-13l20-21c4-4 9-4 13-2l25 14c9-5 19-10 30-12l8-28c1-4 5-8 10-8h29c5 0 10 4 11 8l8 28c10 2 20 7 29 12l25-14c5-2 10-2 13 2l21 21c3 3 4 8 2 13l-14 24 12 30 28 8c4 1 8 6 8 11v29c0 5-4 9-8 10l-28 8-12 30 14 25c2 4 1 9-2 13l-21 20c-3 4-8 5-13 2l-25-14c-9 6-19 10-29 13l-8 27c-1 5-6 8-11 8Zm-77-58h3c10 6 21 11 32 14 2 0 3 1 4 3l8 30 1 1h29l1-1 9-30c0-2 2-3 3-3 12-3 23-8 33-14h5l27 15h1l21-20v-1l-15-28v-5c6-10 10-21 13-32l4-4 30-8 1-1v-29l-1-1-30-9c-2 0-3-2-4-4-3-11-7-22-13-32v-5l15-27v-1l-21-21h-1l-27 15h-5c-10-6-21-11-33-13-1-1-3-2-3-4l-9-30-1-1h-29l-1 1-8 30-4 4c-11 2-22 7-32 13h-5l-28-15h-1l-20 21-1 1 16 27v5c-7 10-11 21-14 32 0 2-2 4-3 4l-30 9-1 1v29l1 1 30 8c1 1 3 2 3 4 3 11 7 22 14 32v5l-16 28 1 1 20 20h1l28-15h2Z'
					/>
					<path
						className='rotate rotateLeft'
						fill={theme.color.primary}
						d='M109 369H94c-4 0-7-3-8-6l-4-14c-5-1-10-3-14-6l-13 7c-3 2-7 1-10-1l-11-11c-2-3-3-7-1-10l7-12-6-15-14-3c-3-1-6-5-6-8v-16c0-4 3-7 6-8l14-4c1-5 3-10 6-14l-7-12c-2-4-1-8 1-10l11-11c3-3 7-4 10-2l13 7 14-6 4-13c1-4 4-6 8-6h15c4 0 7 2 8 6l4 13 14 6 13-7c3-2 7-1 9 2l11 11c3 2 4 6 2 10l-7 12 6 14 13 4c4 1 6 4 6 8v16c0 3-2 6-6 8l-13 3-6 15 7 12c2 3 1 7-2 10l-11 11c-2 2-6 3-9 1l-13-7c-4 3-9 5-14 6l-4 14c-1 3-4 6-8 6Zm-14-10h13l4-15 4-4c6-1 11-4 17-7h5l13 8 9-9-7-14v-5l7-17c0-2 2-3 3-3l15-5v-13l-15-4c-1-1-3-2-3-4l-7-16v-5l7-14-9-9-13 7h-5l-17-7c-2 0-3-2-4-3l-4-15H95l-4 15c-1 1-2 3-4 3l-17 7h-5l-13-7-10 9 8 14v5c-3 5-6 10-7 16l-4 4-15 4v13l15 5c2 0 3 1 4 3 1 6 4 12 7 17v5l-8 14 10 9 13-8h5c5 3 11 6 17 7l4 4 4 15Zm85-83Z'
					/>
					<path
						fill={theme.color.primary}
						d='M101 313a31 31 0 1 1 0-62 31 31 0 0 1 0 62Zm0-52a21 21 0 1 0 0 42 21 21 0 0 0 0-42Z'
					/>
					<path
						fill={theme.color.primary}
						d='M205 167c-6 0-11-1-16-3a5 5 0 0 1 4-10l12 3a29 29 0 1 0-28-20 5 5 0 1 1-9 4c-2-5-3-9-3-14a39 39 0 1 1 40 40Z'
					/>
					<path
						className='rotate reverse rotateTop'
						fill={theme.color.primary}
						d='M213 221h-17c-4 0-7-3-8-7l-4-14-16-7-13 8c-3 2-8 1-10-2l-12-12c-3-2-3-7-2-10l8-13-7-16-14-4c-4-1-7-4-7-8v-17c0-4 3-7 7-8l14-5 7-15-8-14c-1-3-1-7 2-10l12-12c2-2 7-3 10-1l13 7 16-6 4-15c1-3 4-6 8-6h17c4 0 7 3 8 6l5 15 15 6 14-7c3-2 7-1 10 1l12 12c2 3 3 7 1 10l-7 14 6 15 15 5c3 1 6 4 6 8v17c0 4-3 7-6 8l-15 4c-1 6-4 11-6 16l7 13c2 3 1 8-1 10l-12 12c-3 3-7 4-10 2l-14-8-15 7-5 14c-1 4-4 7-8 7Zm-16-10h15l5-17c0-2 2-3 3-3 7-2 13-4 19-8h5l14 8 11-10-9-15 1-5c3-6 6-12 7-18l4-4 16-4v-15l-16-5c-2 0-3-2-4-3-1-7-4-13-7-18l-1-6 9-14-11-11-14 9-5-1c-6-3-12-6-19-7-1-1-3-2-3-4l-5-16h-15l-4 16-4 4c-6 1-12 4-18 7l-5 1-15-9-10 11 8 14v6c-4 5-6 11-8 18 0 1-1 3-3 3l-17 5v15l17 4c2 1 3 2 3 4 2 6 4 12 8 18v5l-8 15 10 10 15-8h5c6 4 12 6 18 8 2 0 3 1 4 3l4 17Z'
					/>
					<path
						fill={theme.color.primary}
						d='m317 354-3-1-12-12c-2-2-2-5 0-7l12-12a5 5 0 0 1 7 7l-9 8 9 9a5 5 0 0 1-4 8Z'
					/>
					<path
						fill={theme.color.primary}
						d='M364 354a5 5 0 0 1-3-8l8-9-8-8a5 5 0 1 1 7-7l12 12c2 2 2 5 0 7l-12 12-4 1Z'
					/>
					<path fill={theme.color.primary} d='m334 354-3-1c-2-1-3-4-1-6l13-24a5 5 0 1 1 9 5l-14 24-4 2Z' />
					<path
						fill={theme.color.focus}
						d='m153 412-4-1-11-11c-2-2-2-6 0-7l11-11a5 5 0 0 1 8 0l11 11a5 5 0 0 1 0 7l-11 11-4 1Zm-4-16 4 4 4-4-4-4-4 4Z'
					/>
					<path
						fill={theme.color.focus}
						d='M353 148c-3 0-5-2-5-5s-3-6-6-6a5 5 0 0 1 0-10c3 0 6-2 6-6a5 5 0 0 1 10 0c0 4 2 6 6 6a5 5 0 0 1 0 10c-4 0-6 3-6 6s-3 5-5 5Z'
					/>
					<path
						fill={theme.color.focus}
						d='M183 462c-2 0-5-3-5-5 0-4-2-6-6-6a5 5 0 0 1 0-10c4 0 6-3 6-6a5 5 0 0 1 10 0c0 3 3 6 6 6a5 5 0 0 1 0 10c-3 0-6 2-6 6 0 2-2 5-5 5Z'
					/>
					<path
						fill={theme.color.focus}
						d='M76 173c-3 0-5-2-5-5s-3-6-6-6a5 5 0 0 1 0-10c3 0 6-3 6-6a5 5 0 0 1 10 0c0 3 2 6 6 6a5 5 0 0 1 0 10c-4 0-6 3-6 6s-3 5-5 5Z'
					/>
				</g>
				<defs>
					<linearGradient id='b' x1='37.4' x2='489.5' y1='162.7' y2='427.8' gradientUnits='userSpaceOnUse'>
						<stop stopColor={theme.color.iconGradientStart} stopOpacity='0' />
						<stop offset='1' stopColor={theme.color.iconGradientStop} />
					</linearGradient>
				</defs>
				<title>{title ?? 'Loading'}</title>
			</svg>
		</Wrapper>
	)
}
